/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import LanguageButton from '../widgets/components/LanguageButton'
import ThemeSwitcherDropdown from './components/utils/ThemeSwitcherDropdown'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100vh'
    }
  }, [])

  return (
    <div className='d-flex flex-column  flex-column-fluid' style={{height: '100vh'}}>
      {/* begin::Body */}
      <div className='d-flex flex-column  p-10 h-100'>
        {/* begin::Form */}
        <div className='d-flex flex-center flex-row-fluid'>
          {/* begin::Wrapper */}
          <div className='w-350px w-md-500px px-10 py-2'>
            <Outlet />
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Form */}

        {/* begin::Footer */}
        <div className='d-flex flex-center flex-wrap px-5'>
          {/* begin::Links */}
          <div className='d-flex fw-semibold text-primary fs-base'>
            <LanguageButton />
            <ThemeSwitcherDropdown />
            {/* <a href='#' className='px-3 d-flex justify-content-center align-items-center' target='_blank'>
              Terms
            </a>

            <a href='#' className='px-3 d-flex justify-content-center align-items-center' target='_blank'>
              Plans
            </a>

            <a href='#' className='px-3 d-flex justify-content-center align-items-center' target='_blank'>
              Contact Us
            </a> */}
          </div>
          {/* end::Links */}
        </div>
        {/* end::Footer */}
      </div>
      {/* end::Body */}

      {/* begin::Aside */}
      
        {/* begin::Content */}
        {/* <div className='d-flex flex-column flex-center py-15 px-5 px-md-15 w-100'> */}
          {/* begin::Logo */}
          {/* <Link to='/' className='mb-12'> */}
            {/* <img alt='Logo' src={toAbsoluteUrl('/media/logos/custom-1.png')} className='h-75px' /> */}
          {/* </Link> */}
          {/* end::Logo */}

          {/* begin::Image */}
          
          {/* end::Image */}

          {/* begin::Title */}
          {/* <h1 className='text-white fs-2qx fw-bolder text-center mb-7'>
            Fast, Efficient and Productive
          </h1> */}
          {/* end::Title */}

          {/* begin::Text */}
          {/* <div className='text-white fs-base text-center'>
            In this kind of post,{' '}
            <a href='#' className='opacity-75-hover text-warning fw-bold me-1'>
              the blogger
            </a>
            introduces a person they’ve interviewed <br /> and provides some background information
            about
            <a href='#' className='opacity-75-hover text-warning fw-bold me-1'>
              the interviewee
            </a>
            and their <br /> work following this is a transcript of the interview.
          </div> */}
          {/* end::Text */}
        {/* </div> */}
        {/* end::Content */}
      {/* </div> */}
      {/* end::Aside */}
    </div>
  )
}

export {AuthLayout}
